import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  breadcrumb?: string;
  icon?: React.ReactNode;
}

export default function PageHeader({ title, subtitle, actions, breadcrumb, icon }: PageHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6">
      <div>
        {breadcrumb && <p className="text-xs text-muted-foreground mb-1">{breadcrumb}</p>}
        <h1 className="flex items-center gap-2 text-2xl font-semibold text-foreground">{icon}{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
}
